// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4286f1d4","923":"b054e082"}[chunkId] + ".chunk.js";
};